module.exports = {"app_version":"prod-3.17.4-4d51b0d87"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 1356
// module chunks = 181